import { render, staticRenderFns } from "./Appendix.vue?vue&type=template&id=48fea52e&scoped=true&"
import script from "./Appendix.vue?vue&type=script&lang=js&"
export * from "./Appendix.vue?vue&type=script&lang=js&"
import style0 from "./Appendix.vue?vue&type=style&index=0&id=48fea52e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fea52e",
  null
  
)

export default component.exports